import './sidebar-courses.css'

import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Grid,
  Menu,
  Rate,
  Row,
  Spin,
  Typography,
  message,
  theme,
} from "antd";
import {
  CreditCardOutlined,
  DatabaseOutlined,
  LockOutlined,
  LogoutOutlined,
  MessageOutlined,
  StarOutlined,
  ContainerOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getProfileLocal, setCoursesLocal, setProfileLocal } from '../../utils/common';

import Sider from "antd/es/layout/Sider";
import { actualCourseState } from '../Atoms/Course/courseData';
import { api } from "../../services/api";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from 'recoil';

const { useToken } = theme;

const SideBarCourses = () => {

  const menuItem = [
    {
      label: "Pagina Inicial",
      key: "/",
      icon: <UserOutlined />,
    },
    {
      label: "Meus cursos",
      key: "/mycourses",
      icon: <DatabaseOutlined />,
    },
    // {
    //   label: "Biblioteca de Cursos",
    //   key: "/course-library",
    //   icon: <DatabaseOutlined />,
    // },    
    // {
    //   label: "Pergunte ao professor",
    //   icon: <MessageOutlined />,
    //   key: "/ask",
    // },
    {
      label: "Ficha financeira",
      key: "/financial-statement",
      icon: <CreditCardOutlined />,
    },
    {
      label: "Contratos",
      key: "/contracts",
      icon: <ContainerOutlined />,
    },
    {
      label: "Sair",
      key: "/leave",
      icon: <LogoutOutlined />,
    },
  ];

  const auth = useAuth();
  const location = window.location.pathname;

  const [current, setCurrent] = useState(null);
  const [data, setData] = useState([]);

  const { course_hash } = useParams();
  const { token } = useToken();
  const navigate = useNavigate();

  const [getActualCourseState, setActualCourseState] = useRecoilState(actualCourseState);


  const onClickMenu = (item) => {
    const clicked = menuItem.find((_item) => _item.key === item.key);
    setCurrent(item.key);
    if (clicked.key !== "/leave") {
      navigate(clicked.key);
    } else {
      auth.logout();
    }
  };

  const getInfos = async () => {

    try {

      const res = await api.get(`/panel/student-dashboard`)
      localStorage.setItem("dashboard", JSON.stringify(res.data.data));
      setData(res.data.data);

    } catch (error) {
      console.log(error);
    }

  };

  useEffect(() => {
    getInfos();
  }, []);

  useEffect(() => {
    const pathname = location.split("/");
    if (pathname[1] === "")
      setCurrent("/");
    else
      setCurrent(`/${pathname[1]}`);

  }, [location]);

  return (
    <Sider
      style={{
        width: "300px",
        backgroundColor: "transparent",
      }}
    >
      <Card
        style={{
          width: "100%",
          padding: "0px 0px 20px  !important",
          marginBottom: "40px",
          borderRadius: "3px",
        }}
      >
        <div
          style={{
            backgroundColor: token.colorPrimary,
            display: "flex",
            justifyContent: "center",
            height: "140px",
            position: "relative",
          }}
        >
          <Avatar
            style={{
              position: "absolute",
              bottom: "-50px",
              border: "2px solid #FFFFFF",
            }}
            size={100}
            src={"https://www.w3schools.com/w3images/avatar2.png"}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://www.w3schools.com/w3images/avatar2.png";
            }}
          />
        </div>

        <Row
          style={{
            marginTop: "66px",
            display: "flex",
            justifyContent: "center",
            width: "100% !important",
          }}
        >

          <Row
            gutter={50}
            justify="space-between"
            align="middle"
            style={{
              padding: "20px",
              maxWidth: "300px",
            }}
          >
            <Typography
              style={{
                fontStylle: "normal",
                fontWeight: 700,
                lineHeight: "14px",
                marginBottom: "20px",
                color: "#595959",
              }}
            >
              {data?.name}
            </Typography>

            <Row justify="space-between" style={{ width: "100%" }}>
              <Col>Seu progresso nesse curso</Col>
              <Col>0.00%</Col>
            </Row>
            <Button
              className="custom-disabled-button"
              disabled
              type="primary"
              style={{ width: "100%", height: "36px", marginTop: "24px" }}
              icon={<LockOutlined />}
            >
              Emitir certificado
            </Button>
          </Row>
        </Row>
      </Card>

      <Card
        style={{
          width: "100%",
          padding: "0px !important",
          marginBottom: "40px",
        }}
      >
        <Menu onClick={onClickMenu} selectedKeys={[current]} items={menuItem} />
      </Card>
      <Card
        style={{
          width: "100%",
          padding: "20px",
        }}
      >
        <Typography
          style={{
            fontWeight: 700,
            fontSize: "calc(1.275rem + 0.3vw)",
            marginBottom: "1.5rem",
          }}
        >

          Avalie este curso
        </Typography>
        <Row justify="space-between" align="middle">
          <Col span={16}>
            <Rate
              style={{
                fontSize: "24px",
                color: "#FFC107",
              }}
              onChange={(value) => {

                setActualCourseState({
                  ...getActualCourseState,
                  course_rating: {
                    rate: value
                  }
                })

              }}
              value={getActualCourseState?.course_rating?.rate ?? 0}
            />
          </Col>
          <Col span={8}>
            <Button
              type="primary"
              style={{
                borderRadius: "0.25rem",
                padding: "0 0.875rem",
              }}
              onClick={async () => {
                try {

                  await api.post(`/panel/course-ratings/${course_hash}`, {
                    _method: 'PUT',
                    course_hash,
                    rate: getActualCourseState?.course_rating?.rate,
                  })

                  setCoursesLocal((coursesLocal) => {
                    return coursesLocal.map((course) => {
                      if (course.hash === course_hash) {
                        return {
                          ...course,
                          course_rating: {
                            rate: getActualCourseState?.course_rating?.rate
                          }
                        }
                      }
                      return course
                    })
                  })

                  message.success('Avaliação enviada com sucesso!')

                } catch (error) {
                  error?.message && message.error(error.message)
                }
              }}
            >
              Enviar
            </Button>
          </Col>
        </Row>
      </Card>
    </Sider>
  );
};

export default SideBarCourses;
